import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var DEFAULT_TTL = 60;
var CacheConfig = /*#__PURE__*/function () {
  function CacheConfig(cacheProviderConfig) {
    _classCallCheck(this, CacheConfig);
    this.cacheProviderConfig = cacheProviderConfig;
  }
  _createClass(CacheConfig, [{
    key: "cacheName",
    get: function get() {
      return this.cacheProviderConfig.cacheName;
    }
  }, {
    key: "useCase",
    get: function get() {
      return this.cacheProviderConfig.useCase;
    }
  }, {
    key: "ttl",
    get: function get() {
      var _this$cacheProviderCo;
      return (_this$cacheProviderCo = this.cacheProviderConfig.ttl) !== null && _this$cacheProviderCo !== void 0 ? _this$cacheProviderCo : DEFAULT_TTL;
    }
  }, {
    key: "onError",
    get: function get() {
      var _this$cacheProviderCo2;
      return (_this$cacheProviderCo2 = this.cacheProviderConfig.onError) !== null && _this$cacheProviderCo2 !== void 0 ? _this$cacheProviderCo2 : function () {};
    }
  }]);
  return CacheConfig;
}();
export { CacheConfig as default };